import { CookieConstants, KeyConstants } from '../constants'

import router from '../router'
import store from '../store'

// Utilities
import analytics from '../utility/analyticsUtil'
import dialog from '../utility/dialogUtil'
import isEmpty from './isEmpty'
import Language from './languageUtil'
import logger from '../utility/loggerUtil'
import Session from '../utility/sessionUtil'
import wait from '../utility/waitUtil'

class AppBrowserUtil {
  static async openExternalPageInBrowser (url, name) {
    try {
      analytics.setScreenName(name)
      return AppBrowserUtil.openInBrowser(url, '_blank')
    } catch (e) {
      logger.error(`Error opening ${url} site link in browser`)
      logger.debug(e)
      dialog.errorAlert(Language.$t('global.app_browser_error'))
    }
  }

  /**
   * Opens a given URL.
   * @param {String} url - The URL to navigate to.
   * @param {String} target - Determines how to open the URL (possible values: '_self', '_default', '_system').
   */
  static openInBrowser (url, target) {
    const openedWindow = window.open(url, target)

    if (!openedWindow || openedWindow.closed || typeof openedWindow.closed === 'undefined') {
      logger.warn('Popup blocked. Returning false so calling code can handle this.')
      return false // different from 'undefined'
    }

    return undefined // 'undefined' if successfully opened popup
  }

  static async navigateToInvictus (url) {
    try {
      wait.waitStart('navigateToInvictus.navigateToInvictus') // Navigating takes time so display progress until leaving page

      try {
        await store.dispatch('session/getAnsweredSecurityQuestions')

        if (isEmpty(store.state.session.answeredSecurityQuestion)) {
          router.push({ name: 'InvictusSecurityQuestion' })
          return
        }
      } catch (e) {
        logger.error('Error checking security question')
        logger.debug(e)
      }

      const accessToken = Session.getAccessToken()
      const deviceKey = await store.dispatch('session/getCurrentDeviceKey')

      Session.setCookie(CookieConstants.invictusAccessToken.key, accessToken, CookieConstants.invictusAccessToken.ttlMinutes)
      Session.setCookie(KeyConstants.deviceKey, deviceKey, 525600)

      AppBrowserUtil.openInBrowser(url, '_self')

      setTimeout(() => { // If navigation above fails for some reason, hide wait after a while
        wait.waitEnd('navigateToInvictus.navigateToInvictus')
      }, 10000)
    } catch (e) {
      logger.error('Failed to navigate')
      logger.debug(e)
      wait.waitEnd('navigateToInvictus.navigateToInvictus')
    } finally {
      // Intentionally not ending wait spinner. If successful and did not throw an error, let it spin until the page redirects to Inv
    }
  }
}

export default AppBrowserUtil
